import { render, staticRenderFns } from "./ListPrompts.vue?vue&type=template&id=5910f91a"
import script from "./ListPrompts.vue?vue&type=script&lang=js"
export * from "./ListPrompts.vue?vue&type=script&lang=js"
import style0 from "./ListPrompts.vue?vue&type=style&index=0&id=5910f91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports